export const GET_NOTIFICATION_LIST_REQUEST = "GET_NOTIFICATION_LIST_REQUEST"
export const GET_NOTIFICATION_LIST_SUCCESS = "GET_NOTIFICATION_LIST_SUCCESS"
export const GET_NOTIFICATION_COUNT_REQUEST = "GET_NOTIFICATION_COUNT_REQUEST"
export const GET_NOTIFICATION_COUNT_SUCCESS = "GET_NOTIFICATION_COUNT_SUCCESS"
export const READ_NOTIFICATION_REQUEST = "READ_NOTIFICATION_REQUEST"
export const READ_NOTIFICATION_SUCCESS = "READ_NOTIFICATION_SUCCESS"
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS"
